
import { useEffect } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { clearPosSession, getPosSessionState } from '../utils/auth';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAdminToken?: boolean;
  requireFullAdmin?: boolean;
}

export default function ProtectedRoute({ children, requireAdminToken = false, requireFullAdmin = false }: ProtectedRouteProps) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const session = getPosSessionState();
    const denied =
      !session.isAuthenticated ||
      session.isExpired ||
      (requireAdminToken && (!session.hasAdminToken || !session.hasAnyAdminAccess)) ||
      (requireFullAdmin && !session.hasFullAdminAccess);

    if (denied) {
      clearPosSession();
      navigate('/');
    }
  }, [navigate, requireAdminToken, requireFullAdmin]);

  const session = getPosSessionState();
  const denied =
    !session.isAuthenticated ||
    session.isExpired ||
    (requireAdminToken && (!session.hasAdminToken || !session.hasAnyAdminAccess)) ||
    (requireFullAdmin && !session.hasFullAdminAccess);

  if (denied) {
    return <Navigate to="/" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
}
